import { SelectChangeEvent, Stack } from '@mui/material';

import { CfsApi } from '@/api';
import { AppModal, Select } from '@/components';
import { LocalStorageItems } from '@/constants';
import {
  ConfirmTypes,
  useDataStore,
  useToastStore,
  useUserStore,
} from '@/store';

interface UpdateDispositionModalProps {
  cfsId: string;
  open: boolean;
  reason: string;
  onClose: () => void;
}

const UpdateDispositionModal = ({
  cfsId,
  reason,
  open,
  onClose,
}: UpdateDispositionModalProps) => {
  const { updateToast } = useToastStore();
  const { cfsCloseReasons } = useDataStore();
  const { userAgencyId } = useUserStore();

  const handleClose = () => {
    onClose();
  };

  const handleReasonChange = (e: SelectChangeEvent<unknown>) => {
    const newReason = e.target.value as string;
    if (newReason) {
      submitReasonChange(newReason);
    }
  };

  const submitReasonChange = (closeReason: string) => {
    if (!closeReason) {
      return;
    }

    if (userAgencyId) {
      localStorage.setItem(LocalStorageItems.CurrentAgencyId, userAgencyId);
    }

    CfsApi.updateCloseReason(cfsId, closeReason)
      .then(() => {
        handleClose();

        updateToast({
          type: ConfirmTypes.SUCCESS,
          open: true,
          message: 'Updated CFS record disposition',
        });
      })
      .catch((err: any) => {
        updateToast({ open: true, message: err.message });
      });
  };

  const reasonOptions = cfsCloseReasons.map((item) => ({
    value: String(item._id),
    label: item.reason,
  }));

  return (
    <AppModal open={open} onClose={handleClose} title="Set disposition">
      <Stack spacing={2}>
        <Select
          label="Disposition"
          value={reason}
          items={reasonOptions}
          onChange={handleReasonChange}
        />
      </Stack>
    </AppModal>
  );
};

export default UpdateDispositionModal;
